import React from 'react'
import PropTypes from 'prop-types'
import { uploadImage, buildCloudinaryFolder } from '../../../utils/cloudinary'

function ProfilePhotoForm({ photoUrl, onChange, userId, vcardId }) {
  const handleImageUpload = async (e) => {
    const file = e.target.files?.[0]
    if (!file) return
    if (!userId || !vcardId) {
      alert('Falta información de usuario o Dkard')
      return
    }
    try {
      const folder = buildCloudinaryFolder(userId, vcardId, 'profile')
      const { url } = await uploadImage(file, folder)
      onChange(url)
    } catch (error) {
      console.error('Error uploading profile image:', error)
      alert('Error al subir imagen: ' + error.message)
    }
  }

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-4">
        <div className="w-20 h-20 rounded-full overflow-hidden border border-gray-200 bg-gray-100 flex items-center justify-center">
          {photoUrl ? (
            <img src={photoUrl} alt="Perfil" className="w-full h-full object-cover" />
          ) : (
            <span className="text-gray-400 text-xs">Sin foto</span>
          )}
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Foto de perfil</label>
          <input type="file" accept="image/*" onChange={handleImageUpload}
            className="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm" />
        </div>
      </div>
    </div>
  )
}

ProfilePhotoForm.propTypes = {
  photoUrl: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  userId: PropTypes.string,
  vcardId: PropTypes.string
}

export default ProfilePhotoForm